import { hasType, schemaMatches } from '@jsonforms/core';
const hasTypeNumberOrInteger = (schema) => hasType(schema, 'number') || hasType(schema, 'integer');
export const isOneOfNumber = schemaMatches((schema) => hasTypeNumberOrInteger(schema) ||
    (schema.hasOwnProperty('oneOf') &&
        schema.oneOf.some((s) => hasTypeNumberOrInteger(s))));
